import React from 'react';
import { CommandBarButton, IconButton } from '@fluentui/react';
import DetailsTable from '../../../../Table/DetailsTable';

const SeriesTable = ({
    series,
    setSelectedSeries,
    loading,
    editOnClick,
    previewOnClick,
    createOnClick,
    deleteOnClick,
}) => {
    const columns = [
        {
            minWidth: 30,
            maxWidth: 30,
            onRender: (item) => (
                <ContextualMenu
                    editOnClick={editOnClick}
                    previewOnClick={previewOnClick}
                    item={item}
                    deleteOnClick={deleteOnClick}
                    setSelectedSeries={setSelectedSeries}
                />
            ),
        },
        {
            name: 'ID',
            fieldName: 'conPlaylistID',
            minWidth: 40,
            maxWidth: 40,
            isResizable: true,
            isSorted: true,
            isSortedDescending: true,
        },
        {
            name: 'Name',
            fieldName: 'name',
            minWidth: 300,
            maxWidth: 300,
            isResizable: true,
            isSorted: true,
            isSortedDescending: true,
        },
        {
            name: 'Slug',
            fieldName: 'slug',
            minWidth: 300,
            maxWidth: 300,
            isResizable: true,
            isSorted: true,
            isSortedDescending: true,
        },
        {
            name: 'Created Date',
            fieldName: 'createdOn',
            minWidth: 200,
            maxWidth: 200,
            isResizable: true,
            isSorted: true,
            isSortedDescending: true,
        },
        {
            name: 'Icon Url',
            fieldName: 'icon',
            minWidth: 300,
            maxWidth: 350,
            isResizable: true,
            isSorted: true,
            isSortedDescending: true,
            onRender: (item) =>
                item.icon ? (
                    <a href={item.icon} target="_blank" rel="noopener noreferrer">
                        {item.icon}
                    </a>
                ) : null,
        },
    ];

    const items = series ?? [];

    const selectionHook = (items) => {
        setSelectedSeries(items && items[0]);
    };

    return (
        <DetailsTable
            items={items}
            columns={columns}
            selectionHook={selectionHook}
            loading={loading}
            mainColumn={'title'}
            style={{
                position: 'relative',
                height: '80vh',
                width: '80vw',
            }}
            CommandBar={
                <>
                    <CommandBarButton
                        iconProps={{ iconName: 'Edit' }}
                        text="Add Series"
                        onClick={() => createOnClick()}
                    />
                </>
            }
        />
    );
};

const moreIcon = { iconName: 'More' };

const ContextualMenu = ({ editOnClick, deleteOnClick, item, setSelectedSeries, ...rest }) => {
    const menuProps = {
        items: [
            {
                key: 'print',
                iconProps: { iconName: 'Edit' },
                text: 'Edit',
                onClick: () => editOnClick(item.conPlaylistID),
            },
            {
                key: "Delete",
                iconProps: { iconName: "Delete" },
                text: "Delete",
                onClick: () => {
                    setSelectedSeries?.(item);
                    deleteOnClick(item);
                },
            },
        ],
    };

    return <IconButton iconProps={moreIcon} menuProps={menuProps} onRenderMenuIcon={() => {}} {...rest} />;
};

export default SeriesTable;
